// extracted by mini-css-extract-plugin
export default {"container":"CarouselContent_container__EZXru","productCarousel":"CarouselContent_productCarousel__gvar2","reviewCarousel":"CarouselContent_reviewCarousel__CYBE2"};